<template>
  <div style="width:100%;">
    <highcharts
      :options="chartOptions"
      ref="lineCharts"
    ></highcharts>
  </div>
</template>

<script>
import { Chart } from "highcharts-vue";
import Highcharts from "highcharts";

import ApiDashboard from "../../apis/Dashboard"

export default {
  props: {
    partsdata: {
      type: Array
    }
  },

  components: {
    highcharts: Chart
  },

  data() {
    return {
        colors: [
            '#009FD7',
            '#00D99D',
            '#6800D5',
            '#FC3D55',
            '#FFAC00',
            '#666E73',
            '#A5BF7E',
            '#F2EDD0',
            '#F2B66D',
            '#D97B59',
            '#084056',
            '#188367',
            '#9EA66D',
            '#FF914D',
            '#F53005'
        ],
        dataReport: [],
        categories: [],
        dataValues: [],
        chartOptions: {
            chart: {
                type: "column",
            },
            title: {
                text: 'Ventas del mes por producto'
            },
            xAxis: {
                categories: [
                "Producto 1",
                "Producto 2",
                "Producto 3",
                "Producto 4"
                ]
            },
            yAxis: {
                min: 0,
                title: {
                    text: 'Cantidad vendida'
                }
            },
            tooltip: {
                crosshairs: true,
                shared: true
            },
            credits: {
                enabled: false
            },
            plotOptions: {
                column: {
                    pointPadding: 0.2,
                    borderWidth: 0
                }
            },
            series: [
                {
                    name: 'Productos',
                    data: []
                }
            ]
        }
    };
  },
  methods: {
        getSoldProducts() {
            let currentDate = new Date()
            let month = currentDate.getMonth() + 1
            let year = currentDate.getFullYear()

            ApiDashboard.getSoldProducts(month, year).then((response) => {
                this.dataReport = response.data
                this.prepareData()
            }).catch( function(error){
                console.log('Ocurrió un error')
            });
        },
        prepareData() {
            this.categories = []
            this.dataValues = [] 
            this.dataReport.forEach((element, index) => {
                this.categories.push(element.name)
                let itemValue = {
                    color: this.colors[index],
                    y: element.total
                }
                this.dataValues.push(itemValue)
            })
            let valueSeries = []
            valueSeries.push({
                name: 'Productos Vendidos',
                data: this.dataValues
            })
            this.chartOptions.xAxis.categories = this.categories
            this.chartOptions.series = valueSeries
        }
  },
  mounted() {
      this.getSoldProducts()
  }
};
</script>
